import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultarEstadosDeCuentaRest_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultarDatosGeneralesCuenta",
    rutaEndPoint: "/EnterpriseServices/Sel/ConsultarEstadosDeCuentaRest",
    sistemaOrigen: "Web",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

export function builtConsultarEstadosDeCuentaRestInput(
  l_numeroCuenta: string,


) {
  var retorno: ConsultarEstadosDeCuentaRest_Entrada =
    builtConsultarEstadosDeCuentaRest_Entrada(
      builtConsultarEstadosDeCuentaRestInputMessage(l_numeroCuenta)
    );

  return retorno;
}

//ENTRADA
export interface ConsultarEstadosDeCuentaRest_Entrada {
    ConsultarEstadosDeCuentaInputMessage: ConsultarEstadosDeCuentaInputMessage;
}

export function builtConsultarEstadosDeCuentaRest_Entrada(
  l_ConsultarEstadosDeCuentaInputMessage: ConsultarEstadosDeCuentaInputMessage
) {
  var retorno: ConsultarEstadosDeCuentaRest_Entrada = {
    ConsultarEstadosDeCuentaInputMessage:
      l_ConsultarEstadosDeCuentaInputMessage,
  };

  return retorno;
}

export interface ConsultarEstadosDeCuentaInputMessage {
  NumeroCuenta: string;

}

export function builtConsultarEstadosDeCuentaRestInputMessage(
  l_numeroCuenta: string
  
  
) {
  var retorno: ConsultarEstadosDeCuentaInputMessage = {
    NumeroCuenta: l_numeroCuenta
  

  };

  return retorno;
}


//SALIDA 


export interface ConsultarEstadosDeCuentaOutputMessage {
  ConsultarEstadosDeCuentaOutputMessage:{
  EstadoDeCuentaList: EstadoDeCuentaList;
  }
}


export interface EstadoDeCuentaList {
  EstadoDeCuenta: { [key: string]: null | string }[];
}



export interface EstadoDeCuenta {
    
    NumeroFactura :string;
    IdFactura: string;
    Consecutivo: string;
    FechaEmision: string;
    FechaFactura: string;
    FechaVencimiento: string;
    FechaCierre: string;
    Moneda: string;
    MontoFacturado: string;
    Ajustes: string;
    ConsumosDelMes: string;
    PagosAFactura: string,
    InicioPeriodo: string,
    FinPeriodo: string,
    FechaAPagar: string,
    Saldo: string,
    SaldoTotal: string,
    EstatusFormato: string;
}


export type ConsultarEstadosDeCuentaRest_Respuesta = EncabezadoRespuestaInterna &
ConsultarEstadosDeCuentaOutputMessage;